import { UNKNOWN_ERROR_MESSAGE } from '@/config';
import { ModalUtils } from '@/contexts/ModalWrapper';
import httpClient from '@/httpClient';
import { t } from 'i18next';

class FileService {
  getFileName = (header: any) => {
    var disposition = header['content-disposition'];
    if (disposition) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
      }
    }
    return '';
  };

  saveByte2File = (fileName: string, blob) => {
    try {
      const a: any = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      const url = window.URL.createObjectURL(new Blob([blob]));
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      window.setTimeout(() => {
        document.body.removeChild(a);
      }, 200);
    } catch (error) {
      console.log(error);
    }
  };

  downloadAttachmentFile = (file: any, fileName: string | null | undefined) => {
    try {
      const a: any = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      let url = URL.createObjectURL(file);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      window.setTimeout(() => {
        document.body.removeChild(a);
      }, 200);
    } catch (error) {}
  };

  downloadLicenseFile = (id: string) => {
    const loader = ModalUtils.loading({ loadingText: 'Downloading' });
    httpClient
      .get(`/agent-portal/agent-profile/download-license/${id}`, {
        responseType: 'blob',
      })
      .then(res => {
        this.saveByte2File(this.getFileName(res.headers), res.data);
      })
      .catch(() => {
        ModalUtils.error({
          content: t(UNKNOWN_ERROR_MESSAGE),
        });
      })
      .finally(() => {
        if (loader) {
          loader();
        }
      });
  };
}

export const fileService = new FileService();
